module.exports = __webpack_public_path__ + "img/badge_convenzioni_special.5f1ba8f7.jpg";